import React from 'react'
import parser from 'html-react-parser'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

export default function BasicTextWithImage({ data }) {
  const { textWithImageBackgroundColor, textWithImageButtonExternalLink, textWithImageButtonLink, textWithImageButtonText, textWithImageImage, textWithImageImageLink, textWithImageText, textWithImageTitle } = data
  return (
    <section className='mycomponent-3'>
      <div className={`image-and-content-wrap ${textWithImageBackgroundColor}`}>
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-md-6'>
              {textWithImageImage && (
                <figure>{textWithImageImageLink ? (
                  <a href={textWithImageImageLink}>
                    <GatsbyImage image={getImage(textWithImageImage?.localFile)} alt='image' />
                  </a>
                ) : (
                  <GatsbyImage image={getImage(textWithImageImage?.localFile)} alt='image' />
                )}</figure>
              )}

            </div>
            <div className='col-md-6'>
              <div className='img-w-content'>
                {textWithImageTitle && <h2 className='heading-level-2 blue-color'>{textWithImageTitle}</h2>}
                {textWithImageText && parser(textWithImageText)}
                {textWithImageButtonExternalLink ? (
                  <a href={textWithImageButtonExternalLink} className='btn blue-btn'>{textWithImageButtonText}</a>
                ) : (
                  textWithImageButtonLink && <Link to={textWithImageButtonLink.uri} className="btn blue-btn">{textWithImageButtonText}</Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
